import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight, Check } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-[70vh] flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(/assets/hero-bg.jpg)',
            backgroundSize: '100% auto',
            minHeight: '100%'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            {t.hero.title}
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            {t.hero.subtitle}
          </p>

          {/* Features List */}
          {t.hero.features && (
            <div className="mb-8 space-y-1">
              {t.hero.features.map((feature) => (
                <div 
                  key={feature} 
                  className="flex items-center space-x-3 text-white bg-black/20 backdrop-blur-sm px-4 py-1.5 rounded-lg max-w-fit"
                >
                  <Check className="w-5 h-5 text-amber-400 flex-shrink-0" />
                  <span className="text-sm md:text-base font-medium">{feature}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
};

export default Hero;
